import {environment} from '../../environments/environment';

export const CONFIG = {
  API_URL: environment.API
};
